import { useCallback, useEffect } from 'react';
import useUserService from './UseUserService';
import { GlobalRoutes } from '../Utils/NavigationUtils';
import { useHistory } from 'react-router-dom';
import { useStoreState } from '@cb/solaris-react/Utility/Store';
import useUserStore from './UseUserStore';
import { QuickToast } from '../Utils/QuickToast';
export default function useUser() {
    const history = useHistory();
    const userService = useUserService();
    const userStore = useUserStore();
    const [error, setError] = useStoreState(userStore, 'error');
    const [user, setUser] = useStoreState(userStore, 'user');
    const [isLoading, setIsLoading] = useStoreState(userStore, 'isLoading');
    const onUserFetchFail = useCallback((text) => {
        setError(text);
        QuickToast.error(text);
        history.push(GlobalRoutes.Logout);
    }, [history, setError]);
    const refreshUser = useCallback(async () => {
        if (isLoading) {
            return;
        }
        setIsLoading(true);
        try {
            const user = await userService.getCurrentLoggedInUserDetails();
            setUser(user);
            if (user) {
                setError(null);
            }
            else {
                onUserFetchFail('Failed to fetch user details');
            }
        }
        catch (err) {
            onUserFetchFail('Failed to fetch user details');
        }
        finally {
            setIsLoading(false);
        }
    }, [isLoading, onUserFetchFail, setError, setIsLoading, setUser, userService]);
    const updateOnboarding = useCallback(async (hasOnboarded) => {
        try {
            const userInfo = await userService.updateOnboarding(hasOnboarded);
            setUser(userInfo);
        }
        catch (err) {
            onUserFetchFail('Failed to update onboarding information');
        }
    }, [userService, setUser, onUserFetchFail]);
    useEffect(() => {
        if (!isLoading && !user) {
            refreshUser().catch((err) => {
                throw err;
            });
        }
    }, [isLoading, refreshUser, user]);
    return { isLoading, user, error, refreshUser, updateOnboarding };
}
//# sourceMappingURL=UseUser.js.map